var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationRightArrowDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.453,
    height: 16.561,
    viewBox: "0 0 18.453 16.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30452",
    "data-name": "Group 30452",
    transform: "translate(8966.731 1944.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17472",
    "data-name": "Path 17472",
    d: "M14.615,10.226,8.28,3.906,1.946,10.226,0,8.28,8.28,0l8.28,8.28Z",
    transform: "translate(-8956.505 -1944.531) rotate(90)",
    fill: "#6e7987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17596",
    "data-name": "Path 17596",
    d: "M14.615,10.226,8.28,3.906,1.946,10.226,0,8.28,8.28,0l8.28,8.28Z",
    transform: "translate(-8948.278 -1944.53) rotate(90)",
    fill: "#6e7987"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRightArrowDisable);
export default __webpack_public_path__ + "static/media/paginationRightArrowDisable.8cfd527786b2ca4c90e200ae05ee7585.svg";
export { ForwardRef as ReactComponent };